import React, { useState } from 'react';
import FileUploadTemplate from '../../../components/common/FileUpload/FileUploadTemplate';
import { useProduct } from '../../../context/productContext/ProductContextProvider.jsx';

const UploadProductFile = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { uploadProductFile } = useProduct();

  const handleFilesSelected = (files) => {
    if (files.length !== 1) {
      alert('Please upload exactly one file.');
      return;
    }
    setSelectedFiles(files);
  };

  const handleUpload = async (files) => {
    if (files.length === 1) {
      await uploadProductFile(files[0]);
      setSelectedFiles([]); // Clear selected files after successful upload
    } else {
      alert('Please select a file to upload.');
    }
  };

  return (
    <div>
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4"></h2>
        <p className="text-gray-500 mb-6 text-center">
          Please upload a CSV file containing product data.
        </p>

        <FileUploadTemplate
          acceptedFileTypes={['.csv']}
          onFilesSelected={handleFilesSelected}
          multiple={false}
          onUpload={handleUpload}
          maxFiles={1}
        />
      </div>
      <div className="overflow-x-auto rounded-lg bg-gray-50 shadow-sm">
        <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
          <thead className="bg-gray-100 sticky top-0">
            <tr>
              {[
                'Item Code',
                'Old Code',
                'Managed Range',
                'Group',
                'Description',
                'Unit',
                'Status',
                'Condition',
                'ABC Class',
                'FLC Page No.',
                'Web Ribbon',
                'Internet Flag',
                'Internet Tree',
                'Brand',
                'APN/Manuf',
                'Reorder Policy',
                'Standard Cost',
                'Replacement Cost',
                'Sales Cost',
                'Region',
                'Price 0 (ex GST)',
                'Qty Break 1',
                'Price 1 (ex GST)',
                'Qty Break 2',
                'Price 2 (ex GST)',
                'Qty Break 3',
                'Price 3 (ex GST)',
                'Qty Break 4',
                'Price 4 (ex GST)',
                'Price Last Change',
                'Whse',
                'Bin Loc.',
                'On Hand',
                'Current Orders',
                'Back Orders',
                'On Order',
                'Minimum stock',
                'Maximum stock',
                'Avg Mth Demand',
                'Avg cost',
                'Supplier',
                'Supplier Item',
                'Priority',
                'Unit',
                'Conv Factor',
                'Pack Qty',
                'E.O.Q.',
                'Last Buy Date',
                'Last Buy Price',
                'Tax Code',
                'Stock last sale',
                'Menu Name',
                'Seq',
                'Date Stamp',
                'Source',
                'Buyer/Planner',
              ].map((header, index) => (
                <th
                  key={index}
                  className="py-3 px-4 font-semibold text-gray-600 text-center whitespace-nowrap"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            <tr>
              {[...Array(50)].map((_, index) => (
                <td key={index} className="py-2 px-4 text-center">
                  Sample Data
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UploadProductFile;
